import React from "react";
import { useTranslation } from "@litres-libs/i18n";
import { StyledLink } from "@litres/ui-kit/link";
import { capitalizeFirstLetter } from "../../utils";
import type { IItemProps } from "../../types";
import styles from "./Item.module.scss";

export const Item = (props: IItemProps): JSX.Element => {
  const { genre } = props;

  const { t } = useTranslation();

  const { url = "", subgenres, arts_count: artsNumber, name } = genre;

  const getTitle = (): string => {
    const artsCount = artsNumber ? +artsNumber : 0;
    const subs = subgenres?.length
      ? `${t("{count} поджанр", { count: subgenres.length })}, `
      : "";

    return `${subs} ${t("{count} книга", { count: artsCount })}`;
  };

  return (
    <li className={styles["item-wrapper"]}>
      <StyledLink
        className={styles.item}
        href={url}
        title={getTitle()}
        data-arts-count={artsNumber}
      >
        {capitalizeFirstLetter(t(name))}
      </StyledLink>
    </li>
  );
};
